import { all, put, takeLatest } from "redux-saga/effects";
import { fetchNextPage } from '../list/reducers';

export default function* sagas() {
	yield all([
		takeLatest('auditPaging/auditNextPage', auditNextPage)
	]);
}

function* auditNextPage() {
	yield put(fetchNextPage());
}
